var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col mb-2" }, [
    _c("h4", { staticClass: "font-medium text-gray-600 mb-2" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm.hasAllergies
      ? _c("div", [
          _c(
            "ul",
            { staticClass: "list-disc pl-4" },
            _vm._l(_vm.allergies, function (allergy, index) {
              return _c(
                "li",
                { key: index, staticClass: "font-medium text-gray-400 mb-1" },
                [_vm._v(" " + _vm._s(allergy) + " ")]
              )
            }),
            0
          ),
        ])
      : _c("p", { staticClass: "text-gray-600 pl-4" }, [
          _vm._v(_vm._s(_vm.emptyText)),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }